import { $nocobaseProxy } from ".";

export type RefundApplicationState = "new" | "in_work" | "complete";

export interface RefundApplication {
  id: number;
  reason: string;
  other_reason?: string;
  state: RefundApplicationState;
  ticket_id?: string;
  ticket_title?: string;
  purchase_price?: number;
  initial_sessions?: number;
  remaining_sessions?: number;
  used_sessions?: number;
  refund_amount?: number;
  manager_comment?: string;
  branch?: Array<{
    id: number;
    name: string;
    id_1c: string;
  }>;
  createdAt: string;
  updatedAt: string;
  createdById: number;
}

export interface CreateRefundApplicationData {
  reason: string;
  other_reason?: string;
  state?: RefundApplicationState;
  ticket_id?: string;
  ticket_title?: string;
  purchase_price?: number;
  initial_sessions?: number;
  remaining_sessions?: number;
  used_sessions?: number;
  refund_amount?: number;
}

interface RefundApplicationsListResponse {
  data: RefundApplication[];
  meta: {
    count: number;
    page: number;
    pageSize: number;
    totalPage: number;
  };
}

interface RefundApplicationResponse {
  data: RefundApplication;
}

export async function createRefundApplication(
  _phone: string,
  data: CreateRefundApplicationData,
  clubId?: string
) {
  return $nocobaseProxy.post<RefundApplicationResponse>(
    "/refund_applications:create",
    { ...data, state: data.state || "new" },
    {
      headers: clubId ? { "X-Club-Id": clubId } : undefined,
    }
  );
}

export async function getRefundApplications(
  _phone: string,
  params?: { page?: number; pageSize?: number; clubId?: string }
) {
  return $nocobaseProxy.get<RefundApplicationsListResponse>("/refund_applications:list", {
    params: {
      page: params?.page || 1,
      pageSize: params?.pageSize || 20,
      appends: "branch",
    },
    headers: params?.clubId ? { "X-Club-Id": params.clubId } : undefined,
  });
}
